<template>
  <router-link to="/msgList" class="right-menu-item">
    <el-badge :value="total" style="line-height: initial;">
      <i class="el-icon-message-solid"></i>
    </el-badge>
  </router-link>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default{
    data(){
      return{
        total: '',
        timer: null,
        query:{
          read_status: 0,
          page: 1,
          page_limit: 1
        }
      }
    },
    created() {
      // this.timer = setInterval(()=>{
      //   this.getList()
      // }, 2000)
    },
    destroyed() {
      clearInterval(this.timer)
    },
    methods:{
      getList() {
        userInfoAPI.messageList(this.query).then(res => {
          if (res && res.data.code == 0) {
            this.total = res.data.data.page.count || ''
          }
        }).catch(()=>{
          clearInterval(this.timer)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-icon-message-solid{
    font-size: 22px;
    cursor: pointer;
    vertical-align: -2px;
  }
</style>
